import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useTheme as useStyledTheme } from 'styled-components';
import Home from './pages/Home';
import GlobalStyles from './styles/globalStyles.js';
import { ThemeProvider } from './context/ThemeContext.jsx';
import ProjectDetail from './pages/ProjectDetail';
import WebProjectDetails from './pages/webProjectDetails';

const GlobalStylesWrapper = () => {
  const theme = useStyledTheme();
  return <GlobalStyles theme={theme} />;
};

function App() {
  return (
    <ThemeProvider>
      <GlobalStylesWrapper />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Add more routes here as you create more pages */}
          <Route path="/projects/:id" element={<ProjectDetail />} /> {/* ✅ new route */}
            <Route path="/webProjects/:id" element={<WebProjectDetails />} /> {/* ✅ new route */}
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App; 